import { all, takeLatest } from 'lib/redux';
import {
  LOAD_ORDER_PREFERENCE_PAGE, SAVE_ORDER_PREFERENCES, UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE,
} from 'constants/ActionTypes';
import { getOrderPreferencesSaga } from 'features/userData/UserData.saga';
import { saveOrderPreferencesSaga, updateInputFieldValueSaga } from './OrderPreferences.saga';
/**
 * Defines the watchers related to Order Preferences Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_ORDER_PREFERENCE_PAGE, getOrderPreferencesSaga),
    takeLatest(SAVE_ORDER_PREFERENCES, saveOrderPreferencesSaga),
    takeLatest(UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE, updateInputFieldValueSaga),
  ]);
}
